export const getOrGenerateDeviceId = () => 'webapp';
